import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import DateRangeIcon from '@material-ui/icons/DateRange';

const useStyles = makeStyles((theme) => ({
  prefixIcon: ({ startDate, endDate }) => {
    const dateSelected = startDate || endDate;
    return {
      position: 'absolute',
      left: '9px',
      width: '16px',
      height: '15px',
      zIndex: '2',
      fill: '#222222',
      top: dateSelected ? '60%' : '50%',
      transform: 'translateY(-50%)',
      '&.disabledIcon': {
        fill: 'rgba(0, 0, 0, 0.54)',
      },
    };
  },
  tdInput: ({ startDate, endDate }) => {
    const dateSelected = startDate || endDate;
    return {
      width: '100%',
      position: 'absolute',
      left: '0',
      top: '0',
      zIndex: '1',
      backgroundColor: 'transparent',
      height: '100%',
      '&.disabledInput': {
        zIndex: '6',
      },
      '& input[type=text]:not(.browser-default):disabled': {
        background: 'transparent',
        // large screens
        '@media (min-width: 1024px)': {
          borderBottom: 'none',
        },
      },
      '& .MuiInput-formControl': {
        marginTop: '0',
        height: '100%',
      },
      '& .MuiInputBase-root .MuiInputBase-input': {
        fontSize: '14px',
        paddingLeft: '30px',
        margin: dateSelected ? theme.spacing(2, 0, 0, 0) : '0',
        paddingRight: '30px',
        letterSpacing: '0.4px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        // large screen
        '@media (min-width: 1024px)': {
          borderRight: '0',
          borderTop: '0',
          borderBottom: '0',
          borderLeft: '0',
        },
      },
      '& .MuiInputLabel-formControl': {
        left: '30px',
        fontSize: '14px',
        top: '50%',
        transform: 'translateY(-50%)',
        '&.MuiInputLabel-shrink': {
          transform: 'translateY(-50%) scale(0.85) ',
          top: '33.33%',
        },
      },
      '& .MuiInput-underline:before': {
        border: '0',
      },
      '& .MuiFormLabel-root.Mui-focused': {
        color: 'rgba(0, 0, 0, 0.54)',
      },
    };
  },
}));

const RenderDatePickerValue = (props) => {
  const {
    label, startDate, endDate, disabled, filled = true,
  } = props;
  const classes = useStyles(props);
  const [dtValue, setDtValue] = useState(null);
  const calculateDateValue = () => {
    let dateValue;
    if (disabled) {
      dateValue = '';
    } else {
      dateValue = startDate
        && `${startDate ? moment(startDate).format('MMM DD') : ' ... '} - ${
          endDate ? moment(endDate).format('MMM DD') : ' ... '
        }`;
    }
    setDtValue(dateValue);
  };

  useEffect(() => {
    calculateDateValue();
  }, [startDate, endDate]);

  return (
    <>
      <DateRangeIcon
        className={`${classes.prefixIcon} ${filled ? 'filled' : ''} ${
          disabled ? 'disabledIcon' : ''
        }`}
      />
      <TextField
        id=""
        className={`${classes.tdInput} ${disabled ? 'disabledInput' : ''}`}
        label={label}
        value={dtValue || ''}
        disabled={disabled}
      />
    </>
  );
};

export default RenderDatePickerValue;
